import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTheme } from 'src/hooks';

function PageSEO({ title, description, image, blog, location, children }) {
  const { lang } = useTheme();

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          titleTemplate
        }
      }
      sanitySiteSettings(_id: { eq: "siteSettings" }) {
        siteSeoSettings {
          ...getPageSeo
        }
      }
    }
  `);

  const seo = {
    title,
    description: description ?? data.sanitySiteSettings?.siteSeoSettings?.description,
    image: image ?? data.sanitySiteSettings?.siteSeoSettings?.image?.asset?.url,
    titleTemplate: data.site.siteMetadata.titleTemplate,
    url: location?.href,
  };

  return (
    <Helmet title={seo.title} titleTemplate={seo.titleTemplate} htmlAttributes={{ lang }}>
      {/* General tags */}
      <link rel="preconnect" href="https://js-eu1.hs-analytics.net" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://js-eu1.hsadsixel.net" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://www.facebook.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://www.google-analytics.com" crossOrigin="anonymous" />
      <link rel="dns-prefetch" href="//js-eu1.hs-banner.com" />
      <link rel="dns-prefetch" href="//js-eu1.hs-scripts.com" />
      <link rel="dns-prefetch" href="//connect.facebook.net" />
      <link rel="dns-prefetch" href="//www.recaptcha.net" />
      <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {/* Opengraph tags */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:image" content={seo.image} />
      {blog && <meta property="og:type" content="article" />}
      {/* Twitter tags */}
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {children}
    </Helmet>
  );
}

PageSEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  blog: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};

PageSEO.defaultProps = {
  title: '',
  description: '',
  image: null,
  blog: false,
  children: null,
};

export default PageSEO;
